module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"company":{"menu":["Pagrindinis","DUK","Apie mus","Tinklaraštis","Kontaktai"],"name":"Kompanija"},"solutions":{"menu":["Saulės elektrinės","Įgyvendinti projektai","Finansavimas"],"name":"Paslaugos"},"logos":["Saulės Bendruomenė","Sun Investment Group","Nogrid","ID Energias"],"diplomaAlt":"Diplomas","policy":"Privatumo politika"}}')
  delete Component.options._Ctor
}
